import {useMutation} from 'react-query';
import postSaleAgents from '.';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';

const usePostSaleAgents = (handleAfterSuccess?: () => void) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: ISaleAgentsPayload) => {
      return postSaleAgents(payload);
    },
    onSuccess: data => {
      handleAfterSuccess && handleAfterSuccess();
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export default usePostSaleAgents;
